export const getPathFromPathOrUrl = (pathOrUrl: string) => {
  try {
    const url = new URL(pathOrUrl)
    return `${url.pathname}${url.search}`
  } catch {
    return pathOrUrl
  }
}
